// extracted by mini-css-extract-plugin
export var wrapper = "ContactForm-module--wrapper--7a8fe";
export var picture = "ContactForm-module--picture--29a4c";
export var content = "ContactForm-module--content--c9d46";
export var title = "ContactForm-module--title--cfc6e";
export var modalTitle = "ContactForm-module--modalTitle--078d1";
export var formWrapper = "ContactForm-module--formWrapper--1bb7f";